import {ajax, selectDoc, event, selectArr, removeClassAll} from "../utils/utils";
import {formatMoney} from "../helpers/service.cart";

let props = {};

const updateIFrame = (message = null) => {
    if (message) {
        if (props.iframe3d) {
            if (props.iframe3d.contentWindow) {
                let color = message.replace('-gold', '');
                color = `14k${color.charAt(0).toUpperCase()}${color.substr(1)}_Gold`;
                props.iframe3d.contentWindow.postMessage(color, props.iframeAwsUrl)
            }
        }
    }

    /**
     * Fix zoom issue
     */
    if (!props.zoomFixed) {
        if (props.iframe3d) {
            props.iframe3d.onload = function () {
                if (/(iPad|iPhone)/g.test(navigator.userAgent)) {
                    props.iframe3d.setAttribute('scrolling', 'no');
                }
            }
        }
        props.zoomFixed = true;
    }
}

/**
 *
 * @param cta3d
 */
export const init3DViewAction = (cta3d) => {
    if(cta3d) {
        event(cta3d, 'click', function (e) {
            e.preventDefault()
            cta3d.classList.add('loading');
            props.iframe3d.src = '';
            props.shop3d.href = cta3d.getAttribute('data-url');
            props.title3d.innerHTML = cta3d.getAttribute('data-name')
            props.price3d.innerHTML = cta3d.getAttribute('data-price')
            let renderer = selectDoc('.pdp-page-renderer', props.viewer3d)
            ajax('GET', props.shop3d.href)
                .then(function (response) {
                    response = JSON.parse(response).response;
                    renderer.innerHTML = response;
                    let productData = selectDoc('#product-custom-data data', props.viewer3d)
                    if(productData) {
                        try {
                            let data = productData.getAttribute('value')
                            data = JSON.parse(data.replace(/=>/g, ':'))
                            if(data.product_aws) {
                                props.opener3d.click();
                                props.iframe3d.src = data.product_aws;
                            }
                            cta3d.classList.remove('loading');
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    renderer.innerHTML = '';
                })
        })
    }
}

const initCards = () =>  {
    /**
     * 3D Modal
     */
    props.cards.map(card => {
        let cta3d = selectDoc('.view3d',card);
        init3DViewAction(cta3d);
    });

    props.colors.map(color => {
        event(color, 'click', function () {
            removeClassAll(props.colors, 'active')
            color.classList.add('active')
            updateIFrame(color.getAttribute('data-color'))
        })
    })
}

const initializer = () => {
    props = {
        cards: selectArr('.product-card'),
        body: selectDoc('body'),

        opener3d: selectDoc('#global3d-modal-opener'),
        viewer3d: selectDoc('#global3d-modal'),
        iframe3d: selectDoc('#global3d-modal #g3dvIframe'),
        title3d: selectDoc('#global3d-modal .viewer-footer .title'),
        price3d: selectDoc('#global3d-modal .viewer-footer .price'),
        shop3d: selectDoc('#global3d-modal .viewer-footer .btn'),

        zoomFixed: false,
        colors: selectArr('#global3d-modal .iframeFooter button'),
        iframeAwsUrl: "https://d2zjrbs3h0xk1e.cloudfront.net"
    }

    updateIFrame();
    initCards();
}

export const ProductCard = {
    init: () => initializer()
}
